import { setLocale } from 'react-redux-i18n';

// ------------------------------------
// Actions
// ------------------------------------
function changeLanguage (value = '') {
  return (dispatch) => {
    dispatch(setLocale(value));
  }
}

export const actions = {
  changeLanguage
};



// WEBPACK FOOTER //
// ./src/layouts/Footer/modules/language.js